import { state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';

const app = {
  namespaced: true,
  state,
  getters,
  mutations
};

export default app;
